<div>
	<ng-template #revDynamicModalContent></ng-template>
</div>
